import { privateAPI } from 'services/private';

const normalizeListArgs = (queryArgs = {}) => ({
  page: Number(queryArgs.page) || 1,
  search: queryArgs.search || '',
});

const patchListDraft = (draft, project) => {
  if (!draft?.data?.data) {
    return false;
  }

  const items = draft.data.data;
  const existingIndex = items.findIndex(item => Number(item.id) === Number(project.id));

  if (existingIndex >= 0) {
    items.splice(existingIndex, 1);
  } else {
    // RTK Query updateQueryData uses Immer — mutating draft is intentional
    // eslint-disable-next-line no-param-reassign
    draft.data.total = (draft.data.total || 0) + 1;
  }

  items.unshift(project);

  return true;
};

export default function upsertClientRequestListItem(dispatch, project, queryArgs = { page: 1, search: '' }) {
  if (!project?.id) {
    return false;
  }

  const primaryArgs = normalizeListArgs(queryArgs);
  const fallbackArgs = { page: 1, search: '' };
  const argsToTry = [primaryArgs];

  if (primaryArgs.page !== fallbackArgs.page || primaryArgs.search !== fallbackArgs.search) {
    argsToTry.push(fallbackArgs);
  }

  let patched = false;

  argsToTry.forEach(args => {
    try {
      dispatch(
        privateAPI.util.updateQueryData('listClientRequests', args, draft => {
          if (patchListDraft(draft, project)) {
            patched = true;
          }
        })
      );
    } catch {
      // Cache entry may not exist for these args yet.
    }
  });

  return patched;
}
